import { QuestionMediaUrl } from "./ResumeResponse";

export interface QuestionListModel {
  question: string;
  questionNumber?: string;
  typedAnswer?: string;
  userInput?: UserInput;
  // Programming question specific fields
  problem_statement?: string | null;
  programming_languages?: string | null; // comma separated
  instructions?: string | null;
  submitted_programming_language?: string | null;
  submitted_code?: string | null;
  draft_code?: string | null; // Add this new property
  optionModelList: OptionModel[];
  showFlag?: boolean;
  selected?: boolean;
  saved?: boolean;
  questionId: string;
  dimensionId?: string;
  questionAudio?: string;
  questionType?: string;
  questionMedia?: boolean;
  questionMediaUrls?: QuestionMediaUrl[];
}

export enum UserInput {
  descriptive = "Descriptive",
  multiChoice = "Multiple Choice",
  imageType = "Image",
  programming = "Programming",
}

export interface OptionModel {
  optionNumber?: string;
  optionText?: string;
  optionKey?: string;
  selected?: boolean;
}
